var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Filled Icons/Check Circle",
    clipPath: "url(#clip0_2909_37305)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Check Circle Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.8359 20C16.3589 20 20.8359 15.523 20.8359 10C20.8359 4.477 16.3589 0 10.8359 0C5.31294 0 0.835938 4.477 0.835938 10C0.835938 15.523 5.31294 20 10.8359 20Z",
    fill: "#209765"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Check",
    d: "M6.3125 10.6466L8.89851 13.2326L15.3635 6.76758",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2909_37305"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.835938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckSolid);
export default __webpack_public_path__ + "static/media/checkSolid.c0eea4d53f951c9f74d51916e7f5dfec.svg";
export { ForwardRef as ReactComponent };